interface IProps {
  content: any;
}

const Company = ({ content }: IProps) => {
  return content;
};

export default Company;
